import { useEffect, useState } from "react";

import Context from "../../../Context.js";
import DynamicForm from "../../helperComponents/dynamicForm/DynamicForm.js";
import getUserID from "../../../controllers/getUserID.js";
import { useNavigate } from "react-router-dom";
import { serverLine } from "../../../controllers/network/serverLine.js";
import logout from "../../../controllers/logout.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import goTo from "../../../controllers/goTo.js";
import updateRouteState from "../../../controllers/updateRouteState.js";
import LoadingSection from "../../helperComponents/LoadingSection.js";
import getHostName from "../../../controllers/getHostName.js";
import VerifyEmail from "../../pages/loggedIn/onboarding/VerifyEmail.js";
import AskNameAndGenderPage from "../../pages/loggedIn/onboarding/AskNameAndGenderPage.js";
import AskDobPage from "../../pages/loggedIn/onboarding/AskDobPage.js";
import AskPhoneNumberPage from "../../pages/loggedIn/onboarding/AskPhoneNumberPage.js";
import AskWeightPage from "../../pages/loggedIn/onboarding/AskWeightPage.js";
import AskPhotoPage from "../../pages/loggedIn/onboarding/AskPhotoPage.js";
import universalLocalStorage from "../../../utils/lib/universalLocalStorage.js";

import fetchDataWithCaching from "../../../controllers/network/fetchDataWithCaching.js";
import adminAccess from "../../../data/adminAccess.js";
import { SafeArea } from "@capacitor-community/safe-area";
import styled from "styled-components";
import { createTheme, ThemeProvider } from "@mui/material";

window.nonReactLikeStatus = {};

const CustomSafeArea = styled.div`
  position: relative;
  margin-top: var(--safe-area-inset-top);
  height: calc(100dvh - var(--safe-area-inset-top));
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  overflow-y: scroll;
`;

function Boilerplate({ children }) {
  const [loggedInUserID, setLoggedInUserID] = useState("LOADING");
  const [formData, setFormData] = useState(false);
  const [notificationData, setNotificationData] = useState({
    general: 0,
    work: 0,
  });
  const [popupFeedItem, setPopupFeedItem] = useState(null);
  const navigate = useNavigate();
  const alert = (message) => {
    toast(message);
  };
  const [colorMode, setColorMode] = useState("LIGHT");
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [scrollData, setScrollData] = useState(null);
  const [adminSettings, setAdminSettings] = useState({});

  let currentPath = window.location.pathname + window.location.search;
  const [currentRoute, setCurrentRoute] = useState(currentPath);
  let initialNonPopupRoute = currentPath;
  const [nonPopupRoute, setNonPopupRoute] = useState(initialNonPopupRoute);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [membershipPlans, setMembershipPlans] = useState([]);

  useEffect(() => {
    SafeArea.enable({
      config: {
        customColorsForSystemBars: true,
        statusBarColor: "#00000000", // transparent
        statusBarContent: "light",
        navigationBarColor: "#00000000", // transparent
        navigationBarContent: "light",
      },
    });
  }, []);

  let isAdmin = false;

  if (loggedInUser) {
    isAdmin = adminAccess.includes(loggedInUser.email);
  }

  function updateMembershipPlans(useCache) {
    fetchDataWithCaching({
      path: "/membership-plans",
      skipCache: !useCache,
      onFreshData: setMembershipPlans,
    }).then(setMembershipPlans);
  }

  useEffect(() => {
    updateMembershipPlans(true);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setInnerWidth(window.innerWidth);
    });
  }, []);

  useEffect(() => {
    updateAdminSettings();
  }, []);

  function updateAdminSettings(newItemData) {
    if (newItemData) {
      setAdminSettings(newItemData);
    } else {
      serverLine.get("/settings").then(setAdminSettings);
    }
  }

  const theme = createTheme({
    palette: {
      mode: colorMode.toLowerCase(),
      primary: {
        main: "#40a113ff",
        dark: "#40a113ff",
      },
      secondary: {
        main: "#40a113ff",
      },
    },
  });

  window.setNonPopupRoute = setNonPopupRoute;
  window.setCurrentRoute = setCurrentRoute;
  window.setForm = setForm;
  window.navigate = navigate;
  window.doAlert = alert;
  window.loggedInUserID = loggedInUserID;
  window.loggedInUser = loggedInUser;
  window.homeLink = window.location.protocol + "//" + getHostName();
  window.updateLoggedInUser = updateLoggedInUser;

  function updateNotificationData() {
    serverLine.get("/notification-count").then(setNotificationData);
  }

  useState(() => {
    let theFunc = (theEvent) => {
      let newURl = window.location.pathname + window.location.search;

      updateRouteState(newURl);
    };

    window.addEventListener("popstate", theFunc);

    return () => {
      window.removeEventListener("popstate", theFunc);
    };
  }, []);

  useEffect(() => {
    doInitialLoad();
  }, []);

  window.doInitialLoad = doInitialLoad;

  async function doInitialLoad() {
    setLoggedInUser(null);

    let userID = await getUserID();

    console.log("userID", userID);

    if (userID) {
      setLoggedInUserID(userID);
      updateLoggedInUser();
    } else {
      setLoggedInUserID(false);
    }

    removeFormQuery();
    backFeatures();

    let newStatus = await universalLocalStorage.getItem("wellness-color-mode2");
    if (!newStatus) newStatus = "LIGHT";
    updateColorMode(newStatus);
  }

  if (loggedInUserID) {
    if (loggedInUserID == "LOADING") {
      children = <LoadingSection />;
    } else {
      if (!loggedInUser) {
        children = <LoadingSection />;
      } else {
        let onboardingComponent = getOnboardingComponent();

        if (onboardingComponent) children = onboardingComponent;
      }
    }
  }

  window.popupAlert = alert;

  window.popupError = (err) => {
    if (err) {
      if (err.message) {
        alert(err.message);
      } else {
        alert("An Error Occurred");
      }
    }
  };

  // isAdmin = false;
  return (
    <ThemeProvider theme={theme}>
      <Context.Provider
        value={{
          innerWidth,
          isMobile: innerWidth <= 900,
          adminSettings,
          updateAdminSettings,
          //
          //
          isAdmin,
          membershipPlans,
          scrollData,
          setScrollData,
          nonPopupRoute,
          setNonPopupRoute,
          currentRoute,
          setLoggedInUser,

          loggedInUserID,
          popupFeedItem,
          setPopupFeedItem,
          notificationData,
          setNotificationData,
          updateNotificationData,
          popupAlert: alert,
          updateLoggedInUser: updateLoggedInUser,
          updateMembershipPlans,
          loggedInUser: loggedInUser,
          updateColorMode,
          colorMode,
          setForm: setForm,
        }}
      >
        <CustomSafeArea id="mainScrollableElement">
          {children}

          <DynamicForm setForm={setForm} data={formData} />
        </CustomSafeArea>

        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Context.Provider>
    </ThemeProvider>
  );

  async function updateColorMode(newStatus) {
    setColorMode(newStatus);
    setColors(newStatus);
    await universalLocalStorage.setItem("wellness-color-mode2", newStatus);
  }

  function updateLoggedInUser() {
    try {
      serverLine.get("/logged-in-user").then(setLoggedInUser);
    } catch (e) {
      alert.show(e.message);
      console.log("First Fetch Error----------");
      logout();
    }
  }

  function getOnboardingComponent() {
    if (!loggedInUser.emailConfirmed) return <VerifyEmail />;

    if (!loggedInUser.firstName) return <AskNameAndGenderPage />;
    if (!loggedInUser.gender) return <AskNameAndGenderPage />;

    if (!loggedInUser.dateOfBirth) return <AskDobPage />;

    // return <AskDobPage />;

    if (!loggedInUser.phoneNumber) return <AskPhoneNumberPage />;

    if (!loggedInUser.weight && !loggedInUser.skipWeight)
      return <AskWeightPage />;

    // if (!loggedInUser.membershipType && !loggedInUser.skipMembership)
    //   return <AskMembershipPage />;

    if (!loggedInUser.profileImage && !loggedInUser.skipProfileImage)
      return <AskPhotoPage />;
  }

  function setColors(newVal) {
    let darkTheme = {
      bgColor: "#000000",
      rootBackgroundColor: "#000000",
      foreground: "#111111",
      bgColorDark: "#000000",
      bgColorLight: "#111111",
      bgColor2: "#000000",
      color: "#ffffff",
      accentBorder: "#89da3078",

      // accentColor: "#dde90c",
      accentLight: "#cbd065",
      accentVeryLight: "rgb(209, 218, 48 , 0.37)",
      translucentLight: "rgb(212 226 227 / 2%)",
      translucent: "rgb(212 226 227 / 10%)",
      translucentHard: "rgba(255,255,255,0.2)",
      mainGradient: "linear-gradient(90deg, #ced400 0%, #75a500 100%)",
      glassGradient:
        "linear-gradient(24deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3))",
      highlightGradient:
        "linear-gradient(45deg, #d4cfcf1c, #000000, #c8c8c824)",
      highlightBorder: "1px solid #d1da303b",

      //

      surface: "#151515ff",
      surface2: "#000000ac",
      surface3: "#00000076",
      elementAlt: "#111",
      element: "#fff",
      elementDim: "#ffffff93",
      border: "#ffffff1c",
      accentColor: "#7fbf1a",
      accentAlt: "#000000ff",

      //

      navBarBg: "#181917",
      navBarElement: "#ffffffff",
      highlightBackground: "#171716",
      highlightBackgroundDark: "#181818",
    };

    let lightTheme = {
      rootBackgroundColor: "#fbfbfbff",
      bgColor: "#ffffffff",
      foreground: "#e3e3e3ff",
      bgColorDark: "#b8b8b8ff",
      bgColorLight: "#ddddddff",
      bgColor2: "#ddddddff",
      color: "#000000ff",
      accentBorder: "#71da3078",

      // accentColor: "#dde90c",
      accentLight: "#92d554ff",
      accentVeryLight: "rgba(209, 218, 48, 0.37)",
      translucentLight: "rgba(212, 226, 227, 0.02)",
      translucent: "rgba(0, 0, 0, 0.1)",
      translucentHard: "rgba(0, 0, 0, 0.2)",
      // mainGradient: "linear-gradient(90deg, #b2be11ff 0%, #DEDC00 100%)",
      mainGradient: "linear-gradient(145deg, #b4cd32, #2eb82e)",
      glassGradient:
        "linear-gradient(24deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3))",
      highlightGradient:
        "linear-gradient(45deg, #d4cfcf1c, #000000, #c8c8c824)",
      highlightBorder: "1px solid #d1da303b",

      //
      surface: "#ffffffff",
      surface2: "#e8e8e8ac",
      surface3: "#e8e8e8ff",
      elementAlt: "#ffffffff",
      element: "#000000ff",
      elementDim: "#00000093",
      border: "#00000040",
      // accentColor: "#D1DA30",
      accentColor: "#82db17ff",
      accentAlt: "#000000ff",

      //

      navBarBg: "#000000ff",
      navBarElement: "#ffffffff",
      highlightBackground: "#ddddddff",
      highlightBackgroundDark: "#c6c6c6ff",
    };

    let colors = darkTheme;

    if (newVal == "DARK") colors = darkTheme;
    if (newVal == "LIGHT") colors = lightTheme;

    document.documentElement.style.setProperty("--navBarBg", colors.navBarBg);

    document.documentElement.style.setProperty(
      "--navBarElement",
      colors.navBarElement
    );

    document.documentElement.style.setProperty(
      "--highlightBackground",
      colors.highlightBackground
    );

    document.documentElement.style.setProperty(
      "--highlightBackgroundDark",
      colors.highlightBackgroundDark
    );

    document.documentElement.style.setProperty(
      "--rootBackgroundColor",
      colors.rootBackgroundColor
    );

    document.documentElement.style.setProperty("--surface", colors.surface);

    document.documentElement.style.setProperty("--surface2", colors.surface2);

    document.documentElement.style.setProperty("--surface3", colors.surface3);

    document.documentElement.style.setProperty(
      "--elementAlt",
      colors.elementAlt
    );

    document.documentElement.style.setProperty("--element", colors.element);

    document.documentElement.style.setProperty(
      "--elementDim",
      colors.elementDim
    );

    document.documentElement.style.setProperty("--border", colors.border);

    document.documentElement.style.setProperty(
      "--accentColor",
      colors.accentColor
    );

    document.documentElement.style.setProperty("--accentAlt", colors.accentAlt);

    //
    document.documentElement.style.setProperty(
      "--highlightBorder",
      colors.highlightBorder
    );

    document.documentElement.style.setProperty(
      "--highlightGradient",
      colors.highlightGradient
    );

    document.documentElement.style.setProperty(
      "--translucentLight",
      colors.translucentLight
    );

    document.documentElement.style.setProperty(
      "--accentBorder",
      colors.accentBorder
    );

    document.documentElement.style.setProperty(
      "--mainGradient",
      colors.mainGradient
    );

    document.documentElement.style.setProperty(
      "--veryLightShadow",
      colors.veryLightShadow
    );

    document.documentElement.style.setProperty(
      "--glassGradientHeader",
      colors.glassGradientHeader
    );

    document.documentElement.style.setProperty(
      "--primaryColor",
      colors.primaryColor
    );

    document.documentElement.style.setProperty(
      "--glassBorder",
      colors.glassBorder
    );

    document.documentElement.style.setProperty(
      "--glassGradient",
      colors.glassGradient
    );

    document.documentElement.style.setProperty(
      "--glassGradientLight",
      colors.glassGradientLight
    );

    document.documentElement.style.setProperty(
      "--glassGradientHard",
      colors.glassGradientHard
    );

    document.documentElement.style.setProperty(
      "--lightShadow",
      colors.lightShadow
    );

    document.documentElement.style.setProperty(
      "--hardShadow",
      colors.hardShadow
    );

    document.documentElement.style.setProperty(
      "--accentLight",
      colors.accentLight
    );

    document.documentElement.style.setProperty(
      "--accentVeryLight",
      colors.accentVeryLight
    );

    document.documentElement.style.setProperty(
      "--bgColorDark",
      colors.bgColorDark
    );

    document.documentElement.style.setProperty("--bgColor", colors.bgColor);
    document.documentElement.style.setProperty(
      "--bgColorLight",
      colors.bgColorLight
    );
    document.documentElement.style.setProperty("--bgColor2", colors.bgColor2);
    document.documentElement.style.setProperty("--color", colors.color);
    document.documentElement.style.setProperty(
      "--translucent",
      colors.translucent
    );
    document.documentElement.style.setProperty(
      "--translucentHard",
      colors.translucentHard
    );
  }

  function backFeatures() {
    window.addEventListener("popstate", (event) => {
      removeFormOnBack();
    });
  }

  function removeFormOnBack() {
    const formPage = getUrlQuery("formPage");
    if (!formPage) {
      setFormData(null);
    }
  }

  function getUrlQuery(field) {
    if (typeof window == "undefined") return null;
    const queryString = window.location.search;
    const urlParamsForm = new URLSearchParams(queryString);
    return urlParamsForm.get(field);
  }

  function setForm(data, noPathChange) {
    if (noPathChange) {
      return setFormData({ data, noPathChange });
    }

    let path = window.location.pathname;
    let queryObj = getUrlQueryObject();

    if (getUrlQuery("formPage") && !data) {
      closeForm();
    } else if (!getUrlQuery("formPage")) {
      queryObj.formPage = "true";

      let thePath = removeLastSlash(path) + queryObjToUrl(queryObj);

      goTo(thePath)();

      setFormData({ data, noPathChange });
    } else {
      setFormData({ data, noPathChange });
    }
  }

  function removeLastSlash(urlString) {
    if (urlString[urlString.length - 1] == "/") {
      return urlString.slice(0, urlString.length - 1);
    } else {
      return urlString;
    }
  }

  function queryObjToUrl(queryInput) {
    let newQueryUrl = "/?";
    let i = 0;
    let queryLen = Object.keys(queryInput).length;
    for (let key in queryInput) {
      if (queryInput[key]) {
        if (i == queryLen - 1) {
          newQueryUrl += `${key}=${queryInput[key]}`;
        } else {
          newQueryUrl += `${key}=${queryInput[key]}&`;
          i++;
        }
      }
    }

    return newQueryUrl;
  }

  function getUrlQueryObject() {
    let data = {};
    let raw = window.location.search.replace(/\?/gi, "").replace(/\//gi, "");
    if (!raw) return data;
    raw = raw.split("&");
    for (let itm of raw) {
      if (!itm) continue;
      itm = itm.split("=");
      if (itm.length == 2) {
        if (itm[1].trim()) {
          data[itm[0]] = itm[1];
        }
      }
    }
    return data;
  }

  function removeFormQuery() {
    //this prevents bug
    //what bug?
    //if url already has form query then
    //on setFormData query won't be pushed

    if (getUrlQuery("formPage")) {
      let path = window.location.pathname;
      let queryObj = getUrlQueryObject();
      delete queryObj.formPage;
      let newPath = "/";

      let queryPath = queryObjToUrl(queryObj);

      if (queryPath == "/?") queryPath = "";

      if (path === "/") {
        newPath = queryPath;
      } else {
        if (path[path.length - 1] == "/" && queryPath[0] == "/") {
          //if query path starts with / and the url path end with /
          queryPath = queryPath.slice(1, queryPath.length);
        }
        newPath = path + queryPath;
      }

      if (newPath[newPath.length - 1] == "/") {
        newPath = newPath.slice(0, newPath.length - 1);
      }

      console.log("newPath", newPath, queryPath);
      if (!newPath) newPath = "/";
      goTo(newPath, { isReplace: true })();
    }
  }

  function closeForm() {
    //sometimes it takes a few seconds to push the router
    //if user presses back before then user might go 2 pages back
    if (getUrlQuery("formPage")) {
      goTo(-1)();
    }
  }
}

export default Boilerplate;
